import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Services from "./components/Services/Services";
import React, { useEffect, useRef } from "react";
import TestimonialsMain from "./components/Testimonials/TestimonialsMain";
import AboutUs from "./components/AboutUs/Index";
import ContactUs from "./components/Contact/Index";
import Gaming from "./components/Gaming/Index";
import Payment from "./components/Payment/Index";
import Tnc from "./components/Tnc/Index";
import Privacy from "./components/Privacy/Index";
import Refunds from "./components/Refunds/Index";
import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

function App() {
  logEvent(analytics, "screen_view", {
    firebase_screen: window.location.pathname,
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const servicesection = useRef(null);
  const contactsection = useRef(null);
  const testimonialsection = useRef(null);
  const aboutsection = useRef(null);

  const gotoServiceSection = () =>
    window.scrollTo({
      top: servicesection.current.offsetTop,
      behavior: "smooth",
    });

  const gotoContactSection = () =>
    window.scrollTo({
      top: contactsection.current.offsetTop,
      behavior: "smooth",
    });

  const gotoTestimonialSection = () =>
    window.scrollTo({
      top: testimonialsection.current.offsetTop,
      behavior: "smooth",
    });

  const gotoAboutSection = () =>
    window.scrollTo({
      top: aboutsection.current.offsetTop,
      behavior: "smooth",
    });

  return (
    <div>
      <Router>
      <Switch>
      <Route path="/" exact><Gaming/> </Route>
      <Route path="/payment/:token"><Payment/></Route>
      <Route path="/tnc"><Tnc/></Route>
      <Route path="/privacy"><Privacy/></Route>
      <Route path="/refunds"><Refunds/></Route>
      <Route path="/contact"><ContactUs/></Route>

      <Route path="/services" >
      <div className = 'mainContainer'>
      <div className = 'bgimg'>
      <Navbar 
      onHomeClick = {scrollToTop} onServiceClick = {gotoServiceSection} 
      onContactClick = {gotoContactSection} onTestimonialClick = {gotoTestimonialSection} onAboutClick = {gotoAboutSection}/>
      
      
      <Home  onContactClick = {gotoContactSection} />
      
      <Services refer = {servicesection} refer2 = {testimonialsection} />
     
      <TestimonialsMain refer = {testimonialsection} />
      
      <ContactUs refer = {contactsection} />
      
      <AboutUs refer = {aboutsection} onHomeClick = {scrollToTop} onServiceClick = {gotoServiceSection} 
      onContactClick = {gotoContactSection} onTestimonialClick = {gotoTestimonialSection} />
       </div>
       </div>
      </Route>
      </Switch>
      </Router>
    </div>
  );
}

export default App;
